import { readJson } from '@wix/cli-fs';
import { join } from 'node:path';
import { variant, fields } from 'variant';
import type { VariantOf } from 'variant';
import type { PackageJson } from 'type-fest';
import { getGitRoot, isInsideGitRepo } from './git-service.js';

export const RepoType = variant({
  None: {},
  Polyrepo: fields<{ rootDir: string }>(),
  Monorepo: fields<{ rootDir: string }>(),
});

export type RepoType = VariantOf<typeof RepoType>;

export async function getRepoType(
  targetParentFolder: string
): Promise<RepoType> {
  if (!(await isInsideGitRepo(targetParentFolder))) {
    return RepoType.None();
  }

  const rootDir = await getGitRoot(targetParentFolder);

  if (await isUsingWorkspaces(rootDir)) {
    return RepoType.Monorepo({
      rootDir,
    });
  }

  return RepoType.Polyrepo({
    rootDir,
  });
}

async function isUsingWorkspaces(rootDir: string) {
  return readJson(join(rootDir, 'package.json'))
    .then((pkgJson) => Boolean((pkgJson as PackageJson).workspaces))
    .catch(() => false);
}
